module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit(_vm.item)
      }
    }
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.name)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_name"
    }
  }, [_vm._v("Nazwa")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "_name"
    },
    model: {
      value: (_vm.item.name),
      callback: function($$v) {
        _vm.$set(_vm.item, "name", $$v)
      },
      expression: "item.name"
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.name) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_tax_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.name))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.tax)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_tax"
    }
  }, [_vm._v("Wartość podatku")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": "%"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "id": "_amount"
    },
    model: {
      value: (_vm.item.tax),
      callback: function($$v) {
        _vm.$set(_vm.item, "tax", $$v)
      },
      expression: "item.tax"
    }
  })], 1), _vm._v(" "), (_vm.errors && _vm.errors.tax) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_tax_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.tax))]) : _vm._e()], 1), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'InvoiceTaxTypeList'
      }
    }
  }, [_c('span', [_vm._v("Powrót")]), _c('svg-icon', {
    attrs: {
      "name": "back"
    }
  })], 1), _vm._v(" "), _c('my-button', {
    attrs: {
      "text": "Zapisz",
      "icon": "tick",
      "type": "submit"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a0fe449","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoicetaxtype/Form.vue
// module id = 799
// module chunks = 0